import { focusFormField, FocusFormFieldOptions } from './focusFormField';

// Focuses the form field whose wrapper carries data-form-field={name}, reusing the
// shared focus engine (tab-switching, wait-until-focusable). Pass suppressOpenOnFocus
// to focus controls like the reference quicksearch without popping their overlay.
export const focusFormFieldByName = (
  fieldName: string,
  options?: FocusFormFieldOptions
): void => {
  const selector = `[data-form-field="${CSS.escape(fieldName.toLowerCase())}"]`;

  focusFormField(() => {
    const wrapper = document.querySelector(selector);
    if (!(wrapper instanceof HTMLElement)) {
      return null;
    }

    // Prefer the checked radio/checkbox so focus lands on the active choice.
    // Skip input[type=hidden] (Ionic's aux-input is unfocusable). Ion-checkbox
    // hosts its real input in shadow DOM, so target the host (tabindex=0,
    // role=checkbox). PrimeReact Dropdown's focusable hidden role="combobox"
    // input matches the generic input selector.
    const focusable =
      wrapper.querySelector<HTMLElement>('input:checked') ??
      wrapper.querySelector<HTMLElement>(
        'input:not([type="hidden"]), textarea, select, ion-checkbox, [role="combobox"], [role="checkbox"]'
      ) ??
      wrapper.querySelector<HTMLElement>('[tabindex]:not([tabindex="-1"])') ??
      wrapper;

    return { wrapper, focusable };
  }, options);
};
